import styled, { css } from 'styled-components';
import { ANIMATION_CURVE, ANIMATION_DURATION, getSpacingToken, getToken, ZIndex } from '@optimus-web/common';
import { Card } from '../Card';

export interface SkipLinksCardProps {
    showSkipLinks?: boolean;
}

export const SkipLinksCard = styled(Card)<SkipLinksCardProps>`
    z-index: -1;
    top: 0;
    left: -999999px;
    position: fixed;
    opacity: 0;
    transform: translateY(-50%);
    transition: transform ${ANIMATION_DURATION.default}ms ${ANIMATION_CURVE.default};
    box-shadow: ${getToken('shadow300')};

    ${(props) =>
        props.showSkipLinks &&
        css`
            z-index: ${ZIndex.High};
            top: ${getSpacingToken('200')}px;
            left: ${getSpacingToken('200')}px;
            opacity: ${getToken('opacity1000')};
            transform: translateY(0);
        `}
`;

export const SkipLinksList = styled.ol`
    padding: 0;
    margin: 0;
    list-style: none;
`;
